import React, { useState } from 'react'
import Grid from '@mui/material/Unstable_Grid2'
import TextField from '@mui/material/TextField'
import { getColor } from '../../config/helpers/Helper'

export default function Eircode(props) {
    
    function getSubtext() {
        const formVariant = props.formVariant
        switch (formVariant) {
            case 'roofSuitability':
                return 'This helps us determine the suitability of your roof'
            case 'topInstallers':
                return 'We will recommend top-rated installers that service your area'
            default:
                return 'We will recommend top-rated installers that service your area'
        }
    }

    return (
        <Grid container alignItems='center' justifyContent='center' spacing={1} sx={{ textAlign: 'center' }}>
            <Grid xs={12}>
                <h2>What's your Eircode?</h2>
                <p className='question-subtext'>{getSubtext()}</p>
            </Grid>
            <Grid xs={12} sm={12}>
                <TextField 
                    //label='Last Name'
                    color={getColor(props.site)} 
                    variant='outlined' 
                    type='text'
                    value={props.eircode} 
                    placeholder='A65 F4E2'
                    size='large'
                    onChange={(e) => props.setEircode(e.target.value)} 
                    style={{width: '100%'}}
                    inputProps = {
                        {
                            sx: {
                                '&::placeholder': {
                                    color: 'rgb(121, 118, 118)',
                                    opacity: 1
                                },
                            },
                        }
                    }
                />
            </Grid>
            {props.hasError &&
                <p className='error-text' style={{marginTop: '1rem'}}>Please enter a valid eircode, you can find yours <a target='_blank' href='https://finder.eircode.ie'>here</a> if you are unsure</p>
            }  
        </Grid>
    )
}